import type {
  AutomatedFormFollowUpCallSettings,
  ContactIntelligenceSettings,
  IncomingCallTriageSettings,
  IntakeLeadGenerationSettings,
  PortalSwitchSummary,
  SwitchboardResponse,
} from '@command-center/switchboard-sdk';
import { request } from './api';

export const switchboardApi = {
  list: () => request<SwitchboardResponse>('/api/switchboard'),
  saveSettings: (key: string, settings: AutomatedFormFollowUpCallSettings | IncomingCallTriageSettings | ContactIntelligenceSettings | IntakeLeadGenerationSettings) =>
    request<{ item: PortalSwitchSummary }>(`/api/switchboard/${encodeURIComponent(key)}/settings`, {
      method: 'PATCH',
      body: JSON.stringify({ settings }),
    }),
  setEnabled: (key: string, enabled: boolean) =>
    request<{ item: PortalSwitchSummary }>(`/api/switchboard/${encodeURIComponent(key)}/state`, {
      method: 'POST',
      body: JSON.stringify({ enabled }),
    }),
};
